import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { homeApi } from '../api/home';
import BottomNav from '../components/BottomNav';
import Navbar from '../components/Navbar';
import Icon from '../components/Icon';
import './Home.css';

const Home = () => {
  const [current, setCurrent] = useState(1);
  const [loading, setLoading] = useState(true);
  const [swiperList, setSwiperList] = useState([]);
  const [bloggerList, setBloggerList] = useState([]);
  const [recommendLibraryList, setRecommendLibraryList] = useState([]);
  const [content, setContent] = useState([]);
  const [bloggerhotList, setBloggerhotList] = useState([]);
  const [mygrouplist, setMygrouplist] = useState([]);
  const navigate = useNavigate();

  const scrollList = [
    { name: '关注' },
    { name: '推荐' },
    { name: '热门' }
  ];

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    if (current === 0) {
      fetchMyGroups();
    }
    fetchContent();
  }, [current]);

  const initData = async () => {
    try {
      setLoading(true);
      await fetchHomeData();
      await fetchRecommendLibrary();
      setLoading(false);
    } catch (error) {
      console.error('初始化数据失败:', error);
      setLoading(false);
    }
  };

  const fetchHomeData = async () => {
    try {
      const result = await homeApi.getGoodslist({ type: 1 });
      if (result.code === 200 || result.code === 1) {
        setSwiperList(result.data.swiperList || []);
        setBloggerhotList(result.data.bloggerhotList || []);
        setBloggerList(result.data.bloggerList || []);
        setContent(result.data.bloggerList || []);
      }
    } catch (error) {
      console.error('获取首页数据失败:', error);
    }
  };

  const fetchRecommendLibrary = async () => {
    try {
      const result = await homeApi.getRecommendList({ limit: 5 });
      if (result.code === 200 || result.code === 1) {
        setRecommendLibraryList(result.data.list || []);
      }
    } catch (error) {
      console.error('获取推荐资料失败:', error);
    }
  };

  const fetchMyGroups = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return;
      }
      
      const result = await homeApi.getMyGroups({ page: 1, limit: 10 });
      if (result.code === 200) {
        setMygrouplist(result.data.list || []);
      }
    } catch (error) {
      console.error('获取我的圈子失败:', error);
    }
  };

  const fetchContent = async () => {
    try {
      let hotType = 1;
      if (current === 0) hotType = 1;
      if (current === 1) hotType = 2;
      if (current === 2) hotType = 3;
      
      console.log('开始获取内容列表:', { hotType });
      
      const result = await homeApi.getGoodslist({ hot_type: hotType, page: 1 });
      
      console.log('内容列表API响应:', result);
      
      if (result.code === 200 || result.code === 1) {
        const list = result.data.list || result.data.data || [];
        
        // 转换字段名，确保前端组件能正确显示
        const formattedList = list.map(item => {
          // 处理时间显示
          let formattedTime = '';
          if (item.create_time) {
            // 检查是否是时间戳
            if (typeof item.create_time === 'number' || !isNaN(item.create_time)) {
              formattedTime = new Date(item.create_time * 1000).toLocaleString('zh-CN');
            } else {
              formattedTime = item.create_time;
            }
          }
          
          // 处理内容，去除HTML标签并截取长度
          let plainContent = '';
          if (item.detail || item.content || item.title) {
            const htmlContent = item.detail || item.content || item.title;
            // 创建一个临时的 DOM 元素来解析 HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlContent;
            plainContent = tempDiv.textContent || tempDiv.innerText || '';
            // 截取前 200 个字符
            if (plainContent.length > 200) {
              plainContent = plainContent.substring(0, 200) + '...';
            }
          }
          
          return {
            ...item,
            avatar: item.wechat_avatar || item.avatar || '', // 文章数据可能没有头像
            nickname: item.nick_name || item.nickname || item.author || item.username || '未知用户',
            content: plainContent, // 使用纯文本内容
            comment_num: item.reply_count || item.comment_num || 0,
            like_num: item.like_num || 0,
            create_time: formattedTime
          };
        });
        
        console.log('格式化后的内容列表:', formattedList);
        setContent(formattedList);
      }
    } catch (error) {
      console.error('获取内容列表失败:', error);
    }
  };

  const handleTabChange = (index) => {
    if (current === index) return;
    
    if (index === 0) {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('请先登录');
        return;
      }
    }
    
    setCurrent(index);
  };

  const handleRefresh = async () => {
    setContent([]);
    if (current === 0) {
      await fetchMyGroups();
    }
    await fetchHomeData();
  };

  const handleLoadMore = async () => {
    console.log('加载更多');
  };

  const navigateTo = (path) => {
    navigate(path);
  };

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div className="home-container">
      <nav className="navbar">
        <div className="nav-content">
          <div className="search-btn" onClick={() => navigateTo('/homePages/search')}>
            <Icon type="ic_search" className="search-icon" />
          </div>
          <div className="tabs">
            {scrollList.map((item, index) => (
              <div
                key={index}
                className={`tab-item ${current === index ? 'active' : ''}`}
                onClick={() => handleTabChange(index)}
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
      </nav>

      <div className="content-area">
        {current === 1 && (
          <div className="tab-content">
            <div className="recommend-section">
              <div className="section-header" onClick={() => navigateTo('/library')}>
                <span>全部资料</span>
                <span className="arrow">→</span>
              </div>
              
              {recommendLibraryList.map((item, index) => (
                <div
                  key={index}
                  className="library-item"
                  onClick={() => navigateTo(`/library/article_detail/${item.id}`)}
                >
                  <div className="library-content">
                    {item.logo && (
                      <div className="library-logo" style={{ backgroundImage: `url(${item.logo})` }}></div>
                    )}
                    <div className="library-info">
                      <div className="library-title">{item.title}</div>
                      <div className="library-meta">
                        <span>{item.category_name}</span>
                        <span>·</span>
                        <Icon type="dingwei4" />
                        <span>{item.view_num || 0}</span>
                      </div>
                    </div>
                    <div className="library-arrow">→</div>
                  </div>
                  {index < recommendLibraryList.length - 1 && <div className="divider"></div>}
                </div>
              ))}
            </div>

            <div className="content-list">
              {content.map((item, index) => (
                <div key={index} className="content-item" onClick={() => navigateTo(`/circle/details/${item.id}`)}>
                  <div className="content-header">
                    <img src={item.avatar || '/avatar.jpg'} alt="" className="author-avatar" />
                    <div className="author-info">
                      <div className="author-name">{item.nickname || item.username}</div>
                      <div className="content-time">{item.create_time}</div>
                    </div>
                  </div>
                  {item.content && (
                    <div className="content-text">{item.content}</div>
                  )}
                  {item.images && item.images.length > 0 && (
                    <div className="content-images">
                      {item.images.map((img, imgIndex) => (
                        <img key={imgIndex} src={img} alt="" className="content-image" />
                      ))}
                    </div>
                  )}
                  <div className="content-footer">
                    <div className="content-stats">
                      <span><Icon type="ic_Like" /> {item.like_num || 0}</span>
                      <span><Icon type="pinglun" /> {item.comment_num || 0}</span>
                    </div>
                  </div>
                  {index < content.length - 1 && <div className="divider"></div>}
                </div>
              ))}
            </div>
          </div>
        )}

        {current === 0 && (
          <div className="tab-content">
            <div className="content-list">
              {content.map((item, index) => (
                <div key={index} className="content-item" onClick={() => navigateTo(`/circle/details/${item.id}`)}>
                  <div className="content-header">
                    <img src={item.avatar || '/avatar.jpg'} alt="" className="author-avatar" />
                    <div className="author-info">
                      <div className="author-name">{item.nickname || item.username}</div>
                      <div className="content-time">{item.create_time}</div>
                    </div>
                  </div>
                  {item.content && (
                    <div className="content-text">{item.content}</div>
                  )}
                  {item.images && item.images.length > 0 && (
                    <div className="content-images">
                      {item.images.map((img, imgIndex) => (
                        <img key={imgIndex} src={img} alt="" className="content-image" />
                      ))}
                    </div>
                  )}
                  <div className="content-footer">
                    <div className="content-stats">
                      <span><Icon type="ic_Like" /> {item.like_num || 0}</span>
                      <span><Icon type="pinglun" /> {item.comment_num || 0}</span>
                    </div>
                  </div>
                  {index < content.length - 1 && <div className="divider"></div>}
                </div>
              ))}
            </div>
          </div>
        )}

        {current === 2 && (
          <div className="tab-content">
            <div className="content-list">
              {content.map((item, index) => (
                <div key={index} className="content-item" onClick={() => navigateTo(`/circle/details/${item.id}`)}>
                  <div className="content-header">
                    <img src={item.avatar || '/avatar.jpg'} alt="" className="author-avatar" />
                    <div className="author-info">
                      <div className="author-name">{item.nickname || item.username}</div>
                      <div className="content-time">{item.create_time}</div>
                    </div>
                  </div>
                  {item.content && (
                    <div className="content-text">{item.content}</div>
                  )}
                  {item.images && item.images.length > 0 && (
                    <div className="content-images">
                      {item.images.map((img, imgIndex) => (
                        <img key={imgIndex} src={img} alt="" className="content-image" />
                      ))}
                    </div>
                  )}
                  <div className="content-footer">
                    <div className="content-stats">
                      <span><Icon type="ic_Like" /> {item.like_num || 0}</span>
                      <span><Icon type="pinglun" /> {item.comment_num || 0}</span>
                    </div>
                  </div>
                  {index < content.length - 1 && <div className="divider"></div>}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      
      {/* 底部导航 */}
      <BottomNav />
    </div>
  );
};

export default Home;